import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../Hooks";
import { selectUser } from "../../reducers/UserReducer";
import { API_URL } from "../../actions/settings";
import AE2CustomerInfo from "../../components/AE2/AE2CustomerInfo";
import LoadingSpinner from "../../components/extras/LoadingSpinner";
import CustomerDashboard from "../../components/AE2/CustomerHomepage/CustomerDashboard";

async function getCustomer(token: any, uuid: any) {
  return fetch(`${API_URL}/customers/${uuid}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((data) => data.json());
}

interface Props {
  id?:string
  // Customer already loaded by the parent, so it doesn't need to be fetched again
  customer?:any
}

const CustomerHomepage: React.FC<Props> = ({id, customer: preloaded}) => {
  const user = useAppSelector(selectUser);
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';
  const customer_id = id || user.customer_id
  const [fetched, setFetched] = useState<any>(null)
  const customer = preloaded || fetched

  useEffect(() => {
    if (!customer_id || preloaded) {
      return
    }
    const handleCustomer = async () => {
      const tkn: any = localStorage.getItem("token");
      const token = `Token ${tkn.slice(1, -1)}`;
      const res = await getCustomer(token, customer_id);
      setFetched(res.data);
    };
    handleCustomer();
  }, [customer_id, preloaded]);

  return (
    <div>
      {customer_id ? (
        !customer ? (
          <LoadingSpinner />
        ) : newUI ? (
          <CustomerDashboard customer={customer} customerId={customer_id} />
        ) : (
          <AE2CustomerInfo item={customer} />
        )
      ) : (
        <div> Your Account Has Not Been Linked To A Customer Account. </div>
      )}
    </div>
  );
};

export default CustomerHomepage;
